import { createAuthClient, type AuthClient } from './auth-client';

let client: AuthClient | undefined;
export const getAuthClient = () =>
  (client ??= createAuthClient(import.meta.env, window.location));
